import { useEffect, useState } from 'react';

import type { TWidgetSize } from '../types';

const getWidgetSize = (width: number): TWidgetSize => {
  if (width >= 1024) {
    return 'l';
  }

  if (width >= 768) {
    return 'm';
  }

  return 's';
};

export const useWidgetSize = (): TWidgetSize => {
  const [size, setSize] = useState<TWidgetSize>('l');

  useEffect(() => {
    const handleResize = () => {
      setSize(getWidgetSize(window.innerWidth));
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return size;
};
